(function (root) {
  'use strict';
  function planRitual(cart, config) {
    if (!config || !config.enabled || !config.available || !Number.isFinite(config.price) || config.price <= 0) return null;
    const ids = config.singleIds.map(String);
    if (ids.length !== 3 || new Set(ids).size !== 3 || ids.includes(String(config.variantId))) return null;
    const items = cart.items || [];
    const eligible = items.filter(item => ids.includes(String(item.variant_id || item.id)) && !item.parent_relationship && !(item.item_components || []).length && !item.selling_plan_allocation && !Object.keys(item.properties || {}).length);
    const groups = ids.map(id => eligible.filter(item => String(item.variant_id || item.id) === id));
    const bundle = items.find(item => String(item.variant_id || item.id) === String(config.variantId) && !item.parent_relationship);
    const existing = bundle ? bundle.quantity : 0;
    const availableSets = config.inventoryLimit == null ? 99 : Math.max(0, config.inventoryLimit - existing);
    const sets = Math.min(availableSets, ...groups.map(group => group.reduce((sum, item) => sum + item.quantity, 0)));
    if (!Number.isInteger(sets) || sets < 1) return null;
    const updates = {};
    let previousPrice = 0;
    for (const group of groups) {
      let remaining = sets;
      for (const item of [...group].sort((a,b) => b.final_price - a.final_price)) {
        if (!remaining) break;
        if (!item.key || !Number.isFinite(item.final_price)) return null;
        const consumed = Math.min(item.quantity, remaining);
        updates[item.key] = item.quantity - consumed;
        previousPrice += consumed * item.final_price;
        remaining -= consumed;
      }
    }
    const bundlePrice = sets * config.price;
    if (bundlePrice >= previousPrice) return null;
    updates[bundle ? bundle.key : String(config.variantId)] = existing + sets;
    return { updates, sets, previousPrice, bundlePrice, saving: previousPrice - bundlePrice };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { planRitual };
  else root.WellvaneCartLogic = Object.freeze({ planRitual });
})(typeof window !== 'undefined' ? window : globalThis);

